export default function PlaceHolder() {
  return <div style={{ marginTop: "10rem" }}></div>
}
